import * as React from 'react';

import Icon from 'components/atoms/Icon';
import { delayed } from 'lib/Job';

type NotificationMessagePropsType = {
	text: string;
	icon: string;
	onEventFinished: Function;
};

type NotificationMessageStateType = {
	mounted: boolean;
};

export class NotificationMessage extends React.Component<NotificationMessagePropsType, NotificationMessageStateType> {
	public static displayName = 'NotificationPoints';

	public state = {
		mounted: false,
	};

	public shouldComponentUpdate() {
		return !this.state.mounted;
	}

	public componentDidMount() {
		this.handleAnimation();
	}

	public componentDidUpdate(prevProps: NotificationMessagePropsType) {
		if (this.props.text !== prevProps.text || this.props.icon !== prevProps.icon) {
			this.handleAnimation();
		}
	}

	public handleAnimation() {
		const { onEventFinished } = this.props;
		delayed(() => {
			this.setState({ mounted: true }, () => {
				delayed(() => {
					this.setState({ mounted: false }, () => {
						delayed(() => {
							onEventFinished();
						}, 200);
					});
				}, 5000);
			});
		}, 800);
	}

	public render() {
		const { text, icon } = this.props;
		const { mounted } = this.state;

		return (
			<div className={`m-notification-message${mounted ? ' state-m-notification-message--visible' : ''}`}>
				<div className="m-notification-message__box">
					<div className="m-notification-message__item">
						<span className="m-notification-message__icon">
							<Icon iconName={icon} />
						</span>
						<span className="m-notification-message__text">{text}</span>
					</div>
				</div>
			</div>
		);
	}
}

export default NotificationMessage;
